// removed by extract-text-webpack-plugin
module.exports = {"large":"_3gZH9-large","default":"KYYkV-default","medium":"_1dZ_Q-medium","material":"QqHtF-material","ios":"yGsmE-ios"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/Styles/Size.scss
// module id = 61
// module chunks = 0